<template>
  <v-card class="item" flat tile>
    <img
      class="d-block item-img"
      :src="files + img + '?resize=1&w=140'"
      :alt="title"
      width="100%"
      height="100%"
    />
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  aspect-ratio: 140 / 52;

  &-img {
    filter: grayscale(1);
    object-fit: contain;
    pointer-events: none;
  }
}
</style>
